export const TrackingControllerFactory: ITrackingController = ({
  trackingService,
}) => {
  return {
    track: async (payload) => {
      const response = await trackingService.track(payload);
      return response;
    },
  };
};
